import wx from 'weixin-js-sdk'
// import { get } from "../api/http"

export function wxShare(shareUrl,shareTitle,shareDesc,imgUrl) {

    wx.ready(function () {

        wx.showAllNonBaseMenuItem()

        wx.updateAppMessageShareData({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: process.env.VUE_APP_WxUrl + shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl ? imgUrl : 'https://yujin-health-prod.oss-cn-beijing.aliyuncs.com/company/yujin.jpeg', // 分享图标
            success: function (res) {
                // 设置成功
                console.log(res);
            },
        })
        wx.updateTimelineShareData({
            title: shareTitle, // 分享标题
            link: process.env.VUE_APP_WxUrl + shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl ? imgUrl : 'https://yujin-health-prod.oss-cn-beijing.aliyuncs.com/company/yujin.jpeg', // 分享图标
            success: function () {
                // 设置成功
            }
        })
    })


    // let url = window.location.href.split("#")[0]
    //
    // get("/wx/signature",{url: url})
    //     .then(res => {
    //         console.log(res);
    //         if(res) {
    //             // 配置微信api
    //             wx.config({
    //                 debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //                 appId: process.env.VUE_APP_AppID, // 必填，公众号的唯一标识
    //                 timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    //                 nonceStr: res.data.noncestr,   // 必填，生成签名的随机串
    //                 signature: res.data.signature, // 必填，签名，见附录1
    //                 jsApiList: ["updateAppMessageShareData","updateTimelineShareData"]
    //             });
    //
    //             wx.ready(function () {
    //                 wx.updateAppMessageShareData({
    //                     title: shareTitle, // 分享标题
    //                     desc: shareDesc, // 分享描述
    //                     link: process.env.VUE_APP_WxUrl + shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //                     imgUrl: 'https://yujin-health-prod.oss-cn-beijing.aliyuncs.com/company/yujin.jpeg', // 分享图标
    //                     success: function (res) {
    //                         // 设置成功
    //                         console.log(res);
    //                     },
    //                 });
    //                 wx.updateTimelineShareData({
    //                     title: shareTitle, // 分享标题
    //                     link: process.env.VUE_APP_WxUrl + shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //                     imgUrl: 'https://yujin-health-prod.oss-cn-beijing.aliyuncs.com/company/yujin.jpeg', // 分享图标
    //                     success: function () {
    //                         // 设置成功
    //                     }
    //                 })
    //             })
    //
    //         }
    //     })
}
